export class TileAnimationFrames {
  constructor(sequence = ["0x1"], uptickOnFrame = 30) {
    this.sequence = sequence;
    this.uptickOnFrame = uptickOnFrame; //Speed. Higher = slow
    this.showFrame = 0;
    this.counter = 0;
  }

  get activeFrame() {
    return this.sequence[this.showFrame];
  }

  tick() {
    this.counter += 1;
    if (this.counter > this.uptickOnFrame) {
      this.counter = 0;
      this.showFrame += 1;
      if (this.showFrame === this.sequence.length) {
        this.showFrame = 0;
      }
    }
  }
}
